// extracted by mini-css-extract-plugin
export default {"section":"global_section__TollF","sectionTitle":"global_sectionTitle__dXtuJ"};